// src/components/MoreAboutMe.tsx
import React from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

const MoreAboutMe: React.FC = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        More About Me
      </Typography>
      <Typography paragraph>
        Additional personal details, hobbies, or interests.
      </Typography>
    </Box>
  );
}

export default MoreAboutMe;
